import { Employee } from "../types";

export const formatTime = (minutes: number): string => {
  const hours = Math.floor(Math.abs(minutes) / 60);
  const mins = Math.abs(minutes) % 60;
  const sign = minutes < 0 ? "-" : "";
  return `${sign}${hours}:${mins.toString().padStart(2, "0")}`;
};

export const getCurrentAverageWorkingMinutesPerDay = (
  employeeDetails: Employee | null
): number => {
  if (!employeeDetails?.plannedMinutesPerDayList || employeeDetails.plannedMinutesPerDayList.length === 0) {
    return 480; // Default to 8 hours if no data available
  }

  try {
    // Get the most recent entry (last item in array when sorted by date)
    const sortedEntries = [...employeeDetails.plannedMinutesPerDayList].sort(
      (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
    );
    const mostRecentEntry = sortedEntries[0];

    if (!mostRecentEntry || !Array.isArray(mostRecentEntry.minutesPerDay)) {
      return 480; // Fallback if not an array
    }

    // Calculate average excluding days with 0 expected work
    const workingDaysMinutes = mostRecentEntry.minutesPerDay.filter((minutes: number) => minutes > 0);
    if (workingDaysMinutes.length === 0) {
      return 480; // Fallback to 8 hours
    }

    return workingDaysMinutes.reduce((sum: number, minutes: number) => sum + minutes, 0) / workingDaysMinutes.length;
  } catch (error) {
    console.warn("Error calculating average working minutes per day:", error);
    return 480; // Fallback to 8 hours
  }
};

export const calculateFTEVacationDays = (minutes: number): string => {
  const sign = minutes < 0 ? "-" : "";
  // Convert minutes to FTE days: minutes / (8 hours * 60 minutes) = standard vacation days
  const standardVacationDays = Math.abs(minutes) / (8 * 60); // 480 minutes = 1 standard day
  return `${sign}${standardVacationDays.toFixed(2)}`;
};
